var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskSafetyInspection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.2 5.26v9.02c0 3.06 4.75 5.55 8.38 7.98.15.09.27.18.42.3.15-.09.27-.18.42-.3 3.63-2.43 8.38-4.92 8.38-7.98V5.26L12 1.29zm14.53 3.26-5.4 5.43-1.32 1.32-3.84-3.84 1.32-1.32 2.52 2.52 5.4-5.43z"
})));
export default SvgTaskSafetyInspection;